// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jj-0";
export var assigneeDetails = "_jj-1";
export var assigneeInfo = "_jj-2";
export var dropdownContainer = "_jj-4";
export var dropdownImage = "_jj-5";
export var editAssigneeInfo = "_jj-3";
export var editAssigneeModalContainer = "_jj-6";
export var hidden = "_jj-8";
export var input = "_jj-7";